(() => {
  const initSlider = (section) => {
    const scope = section || document;
    const slider = scope.querySelector('.pricing-table__slider');
    if (!slider || slider.swiper) return;

    const navigation = scope.querySelector('.pricing-table__navigation');
    const pagination = scope.querySelector('.pricing-table__pagination');
    const columns = Number(slider.dataset.columns || 3);
    const columns750 = columns > 1 ? columns - 1 : 1;

    const swiperParams = {
      slidesPerView: 'auto',
      slidesPerGroup: 1,
      centeredSlides: true,
      spaceBetween: 16,
      breakpoints: {
        750: {
          slidesPerView: columns750,
          slidesPerGroup: columns750,
          centeredSlides: false,
          spaceBetween: 24
        },
        1200: {
          slidesPerView: columns,
          slidesPerGroup: columns,
          centeredSlides: false,
          spaceBetween: 24
        }
      }
    };

    if (pagination) {
      swiperParams.pagination = {
        el: pagination,
        type: 'bullets',
        clickable: true
      };
    }

    if (navigation) {
      swiperParams.navigation = {
        nextEl: navigation.querySelector('.swiper-button-next'),
        prevEl: navigation.querySelector('.swiper-button-prev')
      };
    }

    new Swiper(slider, swiperParams);
  };

  const initAll = () => {
    document.querySelectorAll('.pricing-table').forEach((section) => initSlider(section));
  };

  initAll();

  document.addEventListener('shopify:section:load', (event) => {
    initSlider(event.target);
  });
})();
